
import {FilterInterface, TextFilter} from '../../../../src/Entity/Filter';
import {PropType} from 'vue';

export default {
    props: {
        filter: {
            type: Object as PropType<TextFilter>,
            required: true,
        },
        mode: {
            type: String,
            default: 'active',
        }
    },
    expose: ['support'],
    computed: {
        value: {
            set: function(text: string): void {
                this.filter.value.query = text;
            },
            get: function(): string {
                return this.filter.value.query;
            },
        }
    },
    methods: {
        support(filter: FilterInterface): boolean {
            return filter instanceof TextFilter;
        },
        remove() {
            this.filter.value.clear();
        },
    },
    data() {
        return {};
    }
};
